import {colors} from 'shells/colors/colors';
import {Stack} from 'shells/layout/stack/stack';
import {Switch} from 'shells/switch/switch';
import {Body} from 'shells/typography/body';

import type {HeaderFieldFragment} from 'nutshell-graphql-types';

import {getHeaderFieldIcon} from './helpers';
interface Props {
    headerField: HeaderFieldFragment;
    onToggle: (isEnabled: boolean) => void;
}

export function HeaderFieldToggle(props: Props) {
    const Icon = getHeaderFieldIcon(props.headerField.type);

    return (
        <Stack
            spacing={8}
            isHorizontal={true}
            isFullWidth={true}
            justifyContent='space-between'
            alignItems='center'
        >
            <Stack isHorizontal={true} spacing={8} alignItems='center'>
                <Icon size={20} wrapWithDiv={false} color={colors.grey} fill={colors.grey} />
                <Body isBold={true}>{props.headerField.name}</Body>
            </Stack>
            <Switch
                isOn={props.headerField.isEnabled}
                onChange={() => props.onToggle(!props.headerField.isEnabled)}
                isSmall={true}
                isRounded={true}
                shouldAnimate={false}
                tooltipText={props.headerField.isEnabled ? 'Hide field' : 'Show field'}
            />
        </Stack>
    );
}
